<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'INTEGRATION.LIST_OF_PRICE_LIST' | translate }}</div>
                <div class="tools">

                    <button type="button" class="btn btn-light btn-sm" routerLink="/export">
                        <i class="bi bi-backspace"></i> {{ 'BACK_TO_LIST' | translate }}
                    </button>

                    <button type="button" class="btn btn-primary btn-sm" [disabled]="!checkedCheckBox()" (click)="deleteSelected()">
                        <i class="bi bi bi-trash"></i> {{ 'DELETE_SELECTED' | translate }}
                    </button>

                    <button type="button" class="btn btn-primary btn-sm" (click)="createPriceListFromPublishedProducts()">
                        <i class="bi bi-plus-circle"></i> {{ 'CREATE' | translate }} ({{ 'INTEGRATION.ENABLE_ALL' | translate }})
                    </button>

                    <button type="button" class="btn btn-primary btn-sm" routerLink="/export/integrations/kaspi/create">
                        <i class="bi bi-plus-circle"></i> {{ 'CREATE' | translate }} ({{ 'INTEGRATION.SELECTIVELY' | translate }})
                    </button>

                    <div>
                        <a type="button" class="btn btn-light btn-sm" placement="top" ngbTooltip="{{ 'IMPORT_AND_EXPORT.DOUNLOAD_TEMPLATES' | translate }}" href="/assets/templates/price-list/prays-2021-08-15 00_45_52.22.xml" download="prays-2021-08-15 00_45_52.22.xml">
                            <i class="bi bi-exclamation-triangle-fill"></i>
                        </a>
                        <button class="btn btn-primary btn-sm btn-upload-file" type="button" (click)="fileField.click()" >
                            <i class="bi bi-plus-circle"></i> {{ 'CREATE' | translate }}({{ 'INTEGRATION.FILE' | translate }})
                            <input class="hide" type="file" [multiple]="multiple" #fileField (change)="onUpload($event.target.files)">
                        </button>
                    </div>
                </div>
            </div>

            <div class="card-body">

                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th scope="col" class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_all"
                                        id="select_all" [checked]="isAllCheckBoxChecked()"
                                        [indeterminate]="checkedButNotAllCheckBox()"
                                        (change)="checkAllCheckBox($event)">
                                    <label class="custom-control-label" for="select_all"></label>
                                </div>
                            </th>
                            <th scope="col" class="date">{{ 'IMPORT_AND_EXPORT.DATE' | translate }}</th>
                            <th scope="col" class="offersNumber">{{ 'IMPORT_AND_EXPORT.THE_NIMBER_OF_ORDER' | translate }}</th>
                            <th scope="col" class="action">{{ 'ACTION' | translate }}</th>
                        </tr>
                    </thead>

                    <tbody *ngIf="prices && prices.length > 0">
                        <tr *ngFor="let price of prices; let i = index">
                            <td class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_{{ i }}"
                                        id="select_{{ i }}" [checked]="price.checked"
                                        (change)="selectedCheckBox(i, $event)">
                                    <label class="custom-control-label" for="select_{{ i }}"></label>
                                </div>
                            </td>
                            <td class="date">{{ price.date }}</td>
                            <td class="offersNumber">{{ price.offersNumber }}</td>
                            <td class="action">
                                <button type="button" class="btn btn-light" (click)="downloadFile(price.file)"
                                ngbTooltip="{{ 'DOWNLOAD_FILE' | translate }}">
                                    <i class="bi bi-download"></i>
                                </button>
                                <button type="button" class="btn btn-light" (click)="copyLink(price.file.link)"
                                ngbTooltip="{{ 'INTEGRATION.COPY_LINK' | translate }}">
                                    <i class="bi bi-link"></i>
                                </button>
                                <button type="button" class="btn btn-light"
                                    routerLink="/export/integrations/kaspi/edit/{{ price.id }}" placement="top"
                                    ngbTooltip="{{ 'EDIT' | translate }}">
                                    <i class="bi bi-pencil-square"></i>
                                </button>
                                <button type="button" class="btn btn-light" (click)="onConfirm([price.id])" placement="top"
                                    ngbTooltip="{{ 'DELETE' | translate }}">
                                    <i class="bi bi bi-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>

                    <tbody *ngIf="!prices || prices.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="4">
                                <div class="spinner-bars">
                                    <div class="loadingio-spinner-bars-preLoder-inner">
                                        <div class="preLoder">
                                            <div></div><div></div><div></div><div></div>
                                        </div>
                                    </div>
                                    <div>{{ 'LOADING' | translate }}</div>
                                </div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="4">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="card-footer">
                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
            </div>
        </div>

    </div>
</div>